export const TESTPLAN_STATUS = {
    DRAFT: 'Draft',
    REVIEW: 'Review',
    APPROVED: 'Approved',
    OBSOLETE: 'Obsolete',
};

export const TESTPLAN_STATUS_COLOR = {
    APPROVED: 'success',
};
